import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { credentialsLoginPath, rootPath } from '~/common/paths'
import { Button } from '~/ui/button'
import { useToast } from '~/hooks/use-toast'

export const EmailAuthScreen: React.FC = () => {
  const { clientAuthCode } = useParams<{
    clientAuthCode: string
  }>()
  const { toast } = useToast()
  const navigate = useNavigate()
  const [isValidClient, setIsValidClient] = useState<boolean | null>(null)

  useEffect(() => {
    const storedAuthCodes = JSON.parse(localStorage.getItem('authCodes') || '[]')
    setIsValidClient(storedAuthCodes.includes(clientAuthCode))
  }, [clientAuthCode])
  const handleAuthentication = async () => {
    toast({
      title: 'Email login flow updated',
      description: 'Please log in with your email and password instead.',
      variant: 'default',
    })
    navigate(credentialsLoginPath({}))
  }

  if (isValidClient === null) {
    return <div>Loading...</div>
  }

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center">
      <div className="w-full max-w-md space-y-8">
        <h1 className="text-center text-2xl font-bold">Email Authentication</h1>
        {isValidClient ? (
          <div className="space-y-4">
            <p>Click the button below to complete your authentication.</p>
            <Button onClick={handleAuthentication} className="w-full">
              Authenticate
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <p>
              It appears you're using a different browser than the one you initiated the login from.
              Please return to the original browser or device to complete the authentication
              process.
            </p>
            <Button onClick={() => navigate(rootPath({}))} className="w-full">
              Return to Home
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
